import { NavLink } from 'react-router-dom';
import { Icon, IconName } from './Icon';

const TABS: { to: string; label: string; icon: IconName }[] = [
  { to: '/map',      label: 'Map',      icon: 'map' },
  { to: '/airports', label: 'Airports', icon: 'airport' },
  { to: '/flights',  label: 'Flights',  icon: 'flights' },
  { to: '/aircraft', label: 'Aircraft', icon: 'plane' },
  { to: '/more',     label: 'More',     icon: 'more' },
];

export default function BottomBar() {
  return (
    <nav
      // Fully opaque (was bg-cockpit-800/95) so the home-indicator
      // safe-area below the icon row reads as part of the bar, not
      // a gap where the page's bg bleeds through. The bottom
      // safe-area padding extends the bar's background all the way
      // to the screen edge on iOS (notch + home indicator).
      className="shrink-0 bg-cockpit-800 backdrop-blur border-t border-cockpit-600 shadow-bar"
      style={{ paddingBottom: 'var(--safe-bottom)' }}
    >
      <ul className="flex items-stretch justify-around">
        {TABS.map((t) => (
          <li key={t.to} className="flex-1">
            <NavLink
              to={t.to}
              className={({ isActive }) =>
                [
                  'flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] tracking-wide',
                  'transition-colors active:bg-cockpit-700/60',
                  isActive ? 'text-ember-400' : 'text-cockpit-200',
                ].join(' ')
              }
              end
            >
              <span className="h-6 w-6 flex items-center justify-center">
                <Icon name={t.icon} />
              </span>
              <span>{t.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
